import { api } from "./api";

export const historyService = {
  // Get action log history
  getActionLogHistory: (params) => {
    const deviceId = params.device_id;
    return api.get(`/device/${deviceId}/action_logs`).then((res) => res.data);
  },

  // Get device history
  getDeviceHistory: (deviceId) => {
    //unix datetime for the last 24 hours
    const start_date = Math.floor(Date.now() / 1000) - 86400;
    const end_date = Math.floor(Date.now() / 1000);

    return api
      .get(`/frame/${deviceId}/${start_date}/${end_date}`)
      .then((res) => {
        //sort history by time_created oldest to newest
        const dataSorted = res.data.sort((a, b) => {
          return new Date(a.time_created) - new Date(b.time_created);
        });
        return dataSorted;
      });
  },
};
